import React from "react";
import {cn} from "../../../utils/utils";
import {useSelector} from "react-redux";
import users from "../../users";

import './stars-rating.scss';


const StarsRating = ({rating, className, size}: {
    rating: number;
    className?: string;
    size?: number | 'small' | 'medium' | 'large';
}) => {

    const darkMode = useSelector(users.selectors.isDarkMode)

    const getSizeValue = () => {
        if (typeof size === 'number') {
            return `${size}px`;
        } else if (size === 'small') {
            return '14px';
        } else if (size === 'medium') {
            return '20px';
        } else if (size === 'large') {
            return '27px';
        } else {
            return '33px';
        }
    }

    return (
        <div className={cn("stars-rating", {"stars-rating--dark": darkMode}, className)} draggable={false} style={{
            '--star-size': getSizeValue()
        } as React.CSSProperties}>
            <div className="stars-rating-stars">
                {
                    Array.from({length: 5}).map((_, index) => {
                        return <i key={index} className="fa-solid fa-star" draggable={false}></i>;
                    })
                }
                <div className="stars-rating-stars-overlay" draggable={false}
                     style={{width: `${(rating / 10) * 100}%`}}>
                    {
                        Array.from({length: 5}).map((_, index) => {
                            return <i key={index} className="fa-solid fa-star text-warning" draggable={false}></i>;
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default StarsRating;
